





















/* Created- 23 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import SearchPreview from "@/Ui-Components/Article/Search/SearchPreview.vue";
import { ContentSearchHit } from "../../../Generated/ParticaAPI";
import { ParticaEvent } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "SearchResultsStore",
		components: { SearchPreview }
	})
export default class SearchResultsStore extends Vue {
	@Prop() private results: ContentSearchHit[];
	private preview(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

}
